import { createAction, props } from '@ngrx/store'
import { EmployeeRequest } from './employee-request.state'

// Action to load EmployeeRequest
export const loadEmployeeRequests = createAction(
  '[EmployeeRequest] Load EmployeeRequests',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful EmployeeRequest load
export const loadEmployeeRequestsSuccess = createAction(
  '[EmployeeRequest] Load EmployeeRequest Success',
  props<{
    totalCount: number
    empRequests: EmployeeRequest[]
  }>()
)

// Action for EmployeeRequest load failure
export const loadEmployeeRequestsFailure = createAction(
  '[EmployeeRequest] Load EmployeeRequest Failure',
  props<{ error: string }>()
)

export const createEmployeeRequest = createAction(
  '[EmployeeRequest] Create EmployeeRequest',
  props<{
    userId: string
    requestBy: string
    // approverId: string
    requestType: string
    request: any[]
    status?: string
  }>()
)

export const createEmployeeRequestsSuccess = createAction(
  '[EmployeeRequest] Create EmployeeRequest Success',
  props<{ empRequest: EmployeeRequest }>()
)

export const createEmployeeRequestFailure = createAction(
  '[EmployeeRequest] Create EmployeeRequest Failure',
  props<{ error: any }>()
)

export const updateEmployeeRequest = createAction(
  '[EmployeeRequest] Update EmployeeRequest',
  props<{ id: string; payload: any }>()
)

export const updateEmployeeRequestsSuccess = createAction(
  '[EmployeeRequest] Update EmployeeRequest Success',
  props<{ empRequest: EmployeeRequest }>()
)

export const updateEmployeeRequestFailure = createAction(
  '[EmployeeRequest] Update EmployeeRequest Failure',
  props<{ error: any }>()
)

export const clearEmpRequests = createAction('[EmployeeRequest] Clear Employee Requests')
